(() => {
  // Cart popup elements
  let cartContainer, itemsContainer, totalEl, cartInitialized = false;
  let cachedItems = null;
  let cachedTotal = 0;

  // No-cart popup elements
  let noCartContainer, noCartInitialized = false;

  const initCart = () => {
    if (cartInitialized) return;
    cartContainer = document.querySelector('[data-exit-popup="cart"]');
    itemsContainer = document.querySelector('[data-exit-popup-items]');
    totalEl = document.querySelector('[data-exit-popup-total]');
    if (!cartContainer) return;
    cartInitialized = true;

    // Close buttons
    cartContainer.querySelectorAll('.exit-intent-popup__exit-btn, [data-exit-popup-close]').forEach(btn => {
      btn.addEventListener('click', window.exitPopup.cart.close);
    });

    // Backdrop click
    cartContainer.addEventListener('click', (e) => {
      if (e.target === cartContainer) window.exitPopup.cart.close();
    });
  };

  const initNoCart = () => {
    if (noCartInitialized) return;
    noCartContainer = document.querySelector('[data-exit-popup="nocart"]');
    if (!noCartContainer) return;
    noCartInitialized = true;

    // Close buttons
    noCartContainer.querySelectorAll('.exit-intent-popup__exit-btn, [data-exit-popup-close]').forEach(btn => {
      btn.addEventListener('click', window.exitPopup.noCart.close);
    });

    // Backdrop click
    noCartContainer.addEventListener('click', (e) => {
      if (e.target === noCartContainer) window.exitPopup.noCart.close();
    });

    // Copy coupon functionality
    const copyBtn = noCartContainer.querySelector('[data-copy-coupon]');
    const couponCode = noCartContainer.querySelector('[data-coupon-code]');
    if (copyBtn && couponCode) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(couponCode.textContent.trim()).then(() => {
          copyBtn.classList.add('copied');
          copyBtn.querySelector('span').textContent = 'Copied!';
          setTimeout(() => {
            copyBtn.classList.remove('copied');
            copyBtn.querySelector('span').textContent = 'Copy';
          }, 2000);
        });
      });
    }
  };

  // Escape key handler
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (cartContainer?.classList.contains('exit-intent-popup__container--open')) {
        window.exitPopup.cart.close();
      }
      if (noCartContainer?.classList.contains('exit-intent-popup__container--open')) {
        window.exitPopup.noCart.close();
      }
    }
  });

  const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);

  const updateTotal = (total) => {
    if (totalEl) {
      totalEl.textContent = formatMoney(total);
    }
  };

  // First cart item data (car model, reviews) is rendered in Liquid, so refresh it
  // through the Section Rendering API whenever the first cart item changes.
  const DATA_SECTION_ID = 'exit-intent-popup-data';
  let dataRequestId = 0;

  const refreshFirstItemData = async (items) => {
    const firstItemKey = items?.[0]?.key || '';
    if (firstItemKey === (window.exitPopupFirstItemKey || '')) return;

    const requestId = ++dataRequestId;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const path = root.endsWith('/') ? root.slice(0, -1) : root;
      const response = await fetch(`${path}/cart?sections=${DATA_SECTION_ID}&_=${Date.now()}`, {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      const sections = await response.json();
      const html = new DOMParser().parseFromString(sections[DATA_SECTION_ID] || '', 'text/html');
      const script = html.querySelector('[data-exit-popup-data]');
      if (!script || requestId !== dataRequestId) return;

      const data = JSON.parse(script.textContent);
      window.exitPopupSetData?.(data);
      document.dispatchEvent(new CustomEvent('exitPopup:data-updated', { detail: data }));
    } catch (e) {
      console.error('Failed to refresh exit popup data', e);
    }
  };

  const updateQuantity = async (key, quantity) => {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await response.json();
      cachedItems = cart.items;
      cachedTotal = cart.total_price;
      renderCartItems(cachedItems);
      updateTotal(cachedTotal);
      refreshFirstItemData(cachedItems);
    } catch (e) {
      console.error('Failed to update quantity', e);
    }
  };

  const renderCartItems = (items) => {
    if (!itemsContainer) return;

    if (!items || items.length === 0) {
      itemsContainer.innerHTML = '<li class="exit-intent-popup__empty">Your cart is empty</li>';
      return;
    }

    itemsContainer.innerHTML = items.map(item => `
      <li class="exit-intent-popup__item">
        <div class="exit-intent-popup__item-media">
          <a href="${item.url}">
            <img src="${item.image || item.featured_image?.url || ''}" alt="${item.title}" loading="lazy">
          </a>
        </div>
        <div class="exit-intent-popup__item-info">
          <a href="${item.url}" class="exit-intent-popup__item-title">${item.product_title || item.title}</a>
          ${item.variant_title ? `<div class="exit-intent-popup__item-variant">${item.variant_title}</div>` : ''}
          <div class="exit-intent-popup__item-meta">
            <div class="exit-intent-popup__qty-widget">
              <button type="button" class="exit-intent-popup__qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor"><path d="M2 5h8v2H2z"/></svg>
              </button>
              <span class="exit-intent-popup__qty-value">${item.quantity}</span>
              <button type="button" class="exit-intent-popup__qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor"><path d="M5 2h2v3h3v2H7v3H5V7H2V5h3z"/></svg>
              </button>
            </div>
            <span class="exit-intent-popup__item-price">${formatMoney(item.price)}</span>
          </div>
        </div>
      </li>
    `).join('');

    // Attach event listeners to qty buttons
    itemsContainer.querySelectorAll('.exit-intent-popup__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const action = btn.dataset.action;
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        const newQty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        updateQuantity(key, newQty);
      });
    });
  };

  const fetchAndCacheCart = async () => {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      cachedItems = cart.items;
      cachedTotal = cart.total_price || 0;
      refreshFirstItemData(cachedItems);
    } catch (e) {
      cachedItems = [];
      cachedTotal = 0;
    }
  };

  // Cart events can fire before the cart has settled, so wait a moment and coalesce bursts
  let cartRefreshTimer;
  const scheduleCartRefresh = () => {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(fetchAndCacheCart, 300);
  };

  // Pre-fetch cart during idle time
  const idleCallback = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
  const preFetch = () => idleCallback(fetchAndCacheCart, { timeout: 3000 });
  
  if (document.readyState === 'complete') {
    preFetch();
  } else {
    window.addEventListener('load', preFetch, { once: true });
  }

  // Re-fetch when cart changes
  [
    'rebuy:cart.change',
    'rebuy:cart:change',
    'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart.line-item-decrease',
    'cart:refresh',
    'cart:updated'
  ].forEach((eventName) => document.addEventListener(eventName, scheduleCartRefresh));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCartRefresh);
  }

  // Global API
  window.exitPopup = {
    cart: {
      open: () => {
        initCart();
        if (!cartContainer) return;
        
        if (cachedItems === null) {
          fetchAndCacheCart().then(() => {
            renderCartItems(cachedItems);
            updateTotal(cachedTotal);
          });
        } else {
          renderCartItems(cachedItems);
          updateTotal(cachedTotal);
        }
        
        cartContainer.classList.add('exit-intent-popup__container--open');
        document.body.style.overflow = 'hidden';
      },
      close: () => {
        if (!cartContainer) return;
        cartContainer.classList.remove('exit-intent-popup__container--open');
        document.body.style.overflow = '';
      }
    },
    noCart: {
      open: () => {
        initNoCart();
        if (!noCartContainer) return;
        noCartContainer.classList.add('exit-intent-popup__container--open');
        document.body.style.overflow = 'hidden';
      },
      close: () => {
        if (!noCartContainer) return;
        noCartContainer.classList.remove('exit-intent-popup__container--open');
        document.body.style.overflow = '';
      }
    }
  };
})();

setTimeout(() => {
  (function exitIntentTrigger() {
    const SESSION_KEY = 'exitPopupShown';

    if (sessionStorage.getItem(SESSION_KEY)) return;

    let hasTriggered = false;
    let cartItems = null;
    let isReady = false;

    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.innerWidth < 768;

    const isMacDesktop =
      !isMobile &&
      /Macintosh|MacIntel|MacPPC|Mac68K/i.test(navigator.userAgent);

    let hasUserInteracted = false;
    let lastMouseY = window.innerHeight;
    let lastTopEdgeTime = 0;

    const getCartItemCount = () => {
      const rebuyCart = window.Rebuy?.Cart?.cart || window.rebuy?.cart;
      if (rebuyCart && typeof rebuyCart.item_count !== 'undefined') {
        return rebuyCart.item_count;
      }
      if (window.exitPopup && cartItems !== null) {
        return cartItems.length;
      }
      return null;
    };

    const triggerPopup = () => {
      if (hasTriggered || !isReady) return;

      const itemCount = getCartItemCount();
      if (itemCount === null) return;

      hasTriggered = true;
      sessionStorage.setItem(SESSION_KEY, 'true');

      if (itemCount > 0) {
        window.exitPopup?.cart?.open();
      } else {
        window.exitPopup?.noCart?.open();
      }
    };

    const markInteraction = () => {
      hasUserInteracted = true;
    };

    const handleMouseMove = (e) => {
      if (isMobile || hasTriggered) return;

      hasUserInteracted = true;
      lastMouseY = e.clientY;

      if (e.clientY <= 20) {
        lastTopEdgeTime = Date.now();
      }
    };

    const handleMouseOut = (e) => {
      if (isMobile || hasTriggered || !hasUserInteracted) return;

      const leavingWindow = !e.relatedTarget && !e.toElement;
      const movingUp = e.clientY <= 10 || lastMouseY <= 10;

      if (leavingWindow && movingUp) {
        triggerPopup();
      }
    };

    const handleMouseLeave = (e) => {
      if (isMobile || hasTriggered || !hasUserInteracted) return;

      if (e.clientY <= 10) {
        triggerPopup();
      }
    };

    const handleWindowBlur = () => {
      if (!isMacDesktop || hasTriggered || !hasUserInteracted) return;

      const nearTopRecently = Date.now() - lastTopEdgeTime < 500;
      if (nearTopRecently) {
        triggerPopup();
      }
    };

    let lastScrollY = window.scrollY;
    let lastScrollTime = Date.now();
    let scrollSamples = [];

    const handleScroll = () => {
      if (!isMobile || hasTriggered) return;

      const currentY = window.scrollY;
      const currentTime = Date.now();
      const deltaY = lastScrollY - currentY;
      const deltaTime = currentTime - lastScrollTime;

      if (deltaTime > 0) {
        const velocity = deltaY / deltaTime;
        scrollSamples.push({ velocity, time: currentTime });

        const cutoff = currentTime - 300;
        scrollSamples = scrollSamples.filter((s) => s.time > cutoff);

        if (scrollSamples.length >= 3) {
          const avgVelocity =
            scrollSamples.reduce((sum, s) => sum + s.velocity, 0) / scrollSamples.length;

          if (avgVelocity > 1.5 && currentY > 100) {
            triggerPopup();
          }
        }
      }

      lastScrollY = currentY;
      lastScrollTime = currentTime;
    };

    const waitForReady = () => {
      const checkReady = () => {
        const rebuyCart = window.Rebuy?.Cart?.cart || window.rebuy?.cart;

        if (rebuyCart || document.readyState === 'complete') {
          isReady = true;

          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              cartItems = cart.items || [];
            })
            .catch(() => {
              cartItems = [];
            });
        } else {
          setTimeout(checkReady, 100);
        }
      };

      if (document.readyState === 'complete') {
        setTimeout(checkReady, 500);
      } else {
        window.addEventListener(
          'load',
          () => setTimeout(checkReady, 500),
          { once: true }
        );
      }
    };

    waitForReady();

    if (!isMobile) {
      document.addEventListener('mousemove', handleMouseMove, { passive: true });
      document.addEventListener('mouseout', handleMouseOut);
      document.addEventListener('mouseleave', handleMouseLeave);
      document.addEventListener('mousedown', markInteraction, { passive: true });
      document.addEventListener('keydown', markInteraction, { passive: true });
      window.addEventListener('blur', handleWindowBlur);
    } else {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    document.addEventListener('rebuy:cart.change', (e) => {
      if (e.detail?.cart) cartItems = e.detail.cart.items || [];
    });

    document.addEventListener('rebuy:cart:change', (e) => {
      if (e.detail?.cart) cartItems = e.detail.cart.items || [];
    });
  })();
}, 4000);
